import { toRaw } from 'vue'
import broadcast_mix from '@/mixins/broadcast_mix'
import gameformat from '@/store/gameformat'

const trbc_mix = {
  mixins: [broadcast_mix],
  data() {
    return {
      bc_receiver: null,
    }
  },
  created() {
    this.bc_channelname = `${this.namespace}/strategy_channel`
    this.bc_initialize()
  },
  mounted() {
    this.trbc_registerMain()
  },
  methods: {
    trbc_dataToReceiver({ trigger, namespace }) {
      if (!this.bc_receiver) return

      // let canContinue = trigger === 'loading' ? true : this.overviewSpot
      const canContinue =
        trigger === 'loading'
          ? true
          : trigger === 'trbc_register_receiver'
            ? this.overviewSpot
            : this.hero_spot

      if (!canContinue) return
      // console.log(trigger)

      const data = {
        code: 'bc_send',
        status: null,
        value: null,
      }
      if (this.loading) {
        data.status = 'loading'
        data.value = {
          loading: this.loading,
        }
      } else if (this.overviewSpot) {
        const { query_gameformat, query_cards, query_history } = this.$store.getters
        data.status = 'ok'
        data.value = {
          // toRaw -- Vue3 uses Proxy objects - BroadcastChannel can't handle them
          apiData: toRaw(this.overviewSpot.api_practice),
          gameformat: toRaw(this.gameformat),
          infoVisible: this.infoVisible,
          loading: this.loading,
          trigger,
          query: {
            ...query_gameformat,
            ...query_cards,
            ...query_history,
          },
        }
      } else {
        data.status = 'no-data'
        data.value = null
      }
      this.bc_postMessage(data)
    },
    bc_handleMessage(message) {
      // console.log('TRAINER-MASTER--', message)
      const code = message?.data?.data?.code
      if (code === 'trbc_register_receiver') {
        // debugger
        this.bc_receiver = message.data.origin
        if (this.trainerConfigure) {
          //
        } else {
          // this.trbc_dataToReceiver('register_receiver')
          // debugger
          this.trbc_dataToReceiver({ trigger: 'trbc_register_receiver', namespace: this.namespace })
        }
      }
    },
    trbc_registerMain() {
      const data = {
        code: 'trbc_register_main',
        status: 'ok',
      }
      this.bc_postMessage(data)
    },
  },
}

export default trbc_mix
